<template>
    <div class="panoheader"  @mousemove="handleMouseMove">
      <div class="panoContainer" :style="{height: `${viewPort.height}px`}">
        <img :style="[imageStyleObj]" @load="handleOnLoad" ref="pano" :src="pano">
      </div>
      <div class="content" :style="{height: `${viewPort.height}px`}">
      <div class="fill-height d-flex align-center">
        <v-row>
          <v-col cols="6" class="text-container px-12" :style="[howToTextStyleObj]">
            <v-row class="fill-height" align="end" justify="center" >
              <v-col style="max-width: 430px;">
                <router-link class="d-block" :to="{params: {internal: section.howTO}}">
                  <h2><CharSplitText style="--appear-delay: 200ms;" :text="howToTitle" /></h2>
                  <h4 class="mb-4">{{howToSubtitle}}</h4>
                </router-link>
                <transition appear name="from-below"><DiscoverButton high-visibility style="--appear-delay: 300ms;" :is-white="true" :style="[ctaStyleObj]" class="cta mt-4" :to="{params: {internal: section.howTO}}" /></transition>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" class="text-container px-12" :style="[designerConsciusTextStyleObj]">
            <v-row class="fill-height" align="end" justify="center" >
              <v-col style="max-width: 430px;">
                <router-link class="d-block" :to="{params: {internal: section.consciuousDesigner}}">
                  <h2><CharSplitText style="--appear-delay: 400ms;" :text="designerConsciusTitle" /></h2>
                </router-link>
                <transition appear name="from-below"><DiscoverButton high-visibility style="--appear-delay: 500ms;" :is-white="true"  :style="[ctaStyleObj]" class="cta mt-4" :to="{params: {internal: section.consciuousDesigner}}" /></transition>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      </div>
    </div>
</template>

<script>
import pano from '@/assets/img/awarness_bg.jpg'
import { Viewport } from '@monogrid/vue-lib'
import { RAF, ElasticNumber } from '@monogrid/js-utils'
import Section from '@/constants/responsabilitySection'
// import ResizeObserver from 'resize-observer-polyfill'
import DiscoverButton from '@/atoms/DiscoverButton'
import CharSplitText from '@/atoms/CharSplitText'

export default {
  name: 'PanoHeader',
  mixins: [Viewport],
  components: {
    DiscoverButton,
    CharSplitText
  },
  props: {
    currentSection: {
      type: String,
      default: null
    },
    howToTitle: {
      type: String
    },
    howToSubtitle: {
      type: String
    },
    designerConsciusTitle: {
      type: String
    }
  },
  data () {
    return {
      bgReady: false,
      pano: pano,
      offset: 0,
      baseOffset: 0,
      section: Section,
      imagePositionX: new ElasticNumber(50),
      mousePosition: {
        x: 0,
        y: 0
      }
    }
  },
  computed: {
    imageStyleObj () {
      return {
        transform: `translateX(${-this.imagePositionX.value}%)`
      }
    },
    howToTextStyleObj () {
      return {
        opacity: this.imagePositionX.value >= 53 ? this.currentSection ? 0 : 0.20 : 1,
        transition: 'opacity 500ms'
      }
    },
    designerConsciusTextStyleObj () {
      return {
        opacity: this.imagePositionX.value <= 48 ? this.currentSection ? 0 : 0.20 : 1,
        transition: 'opacity 500ms'
      }
    },
    scrollToStyleObj () {
      return {
        opacity: this.currentSection ? 1 : 0
      }
    },
    ctaStyleObj () {
      return {
        opacity: this.currentSection ? 0 : 1,
        pointerEvents: this.currentSection ? 'none' : 'auto'
      }
    }
  },
  methods: {
    handleOnLoad () {
      this.bgReady = true
      this.baseOffset = (this.$refs.pano.clientWidth - this.viewPort.width) / 2
      // this.offset = this.baseOffset
      RAF.add(this.render)
    },
    handleMouseMove (e) {
      this.mousePosition.x = this.getMousePositionX(e)
    },
    async handleCtaClick (value) {
      this.$emit('catClick', value)
    },
    handleOnResize () {
      this.baseOffset = (this.$refs.pano.clientWidth - this.viewPort.width) / 2
      this.offset = this.baseOffset
    },
    getMousePositionX (event, touchIndex = 0) {
      if (event.touches && event.touches.length > 0) {
        return event.touches[touchIndex].pageX
      }
      return event.pageX
    },
    render () {
      const now = new Date().getTime()
      const delta = (now - this.time) / 1000

      if (this.mousePosition.x > this.viewPort.width * 0.65) {
        this.imagePositionX.target = 55
      } else if (this.mousePosition.x < this.viewPort.width * 0.35) {
        this.imagePositionX.target = 45
      } else {
        this.imagePositionX.target = 50
      }

      if (this.currentSection) {
        if (this.currentSection === Section.consciuousDesigner) {
          this.viewPort.height <= 768 ? this.imagePositionX.target = 60 : this.imagePositionX.target = 74
        } else {
          this.viewPort.height <= 768 ? this.imagePositionX.target = 40 : this.imagePositionX.target = 26
        }
      }

      this.imagePositionX.update(delta)
      this.time = now
    }
  },
  watch: {
    viewPort (newValue, oldValue) {
      this.handleOnResize()
    }
  },
  mounted () {
    this.time = new Date().getTime()
    this.mousePosition.x = this.viewPort.width / 2
  },
  destroyed () {
    RAF.remove(this.render)
  }
}
</script>

<style scoped lang="scss">
  .panoheader {
    position: relative;

    .panoContainer {
      width: 100vw;
      overflow: hidden;

      img {
        height: 100vh;
        width: auto;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  .content {
    color: #131313;
    position: absolute;
    width: 100vw;
    top: 0;
    left: 0;
    // min-height: 750px;

    .text-container {
      // max-width: 400px;

      h2 {
        font-family: $heading-font-family;
        font-size: 4rem;
        line-height: 1;
        color: #fff;

        @include breakpoint('lg-and-down') {
          font-size: 3.5rem;
        }

        @include breakpoint('md-and-down') {
          font-size: 3rem;
        }
      }

      h4 {
        font-size: 1.6rem;
        line-height: 1.5;
        color: #fff;

        @include breakpoint('lg-and-down') {
          font-size: 1.3rem;
        }

        @include breakpoint('md-and-down') {
          font-size: 1rem;
        }
      }
    }

    // .cta {
    //   color: $c-pink;
    //   font-size: 0.9rem;
    // }
  }

  .container {
    position: relative;
  }

  .scrollTo {
    width: 150px;
    height: 80px;
    border-left: 1px solid #000;
    position: absolute;
    top: calc(100vh - 80px);

    p {
      font-family: Serif;
    }
  }
</style>
